import { ProductGroup, ProductGroupDisplayType } from "../../typings/products"
import { GetDisplayedProductsDisplayedProducts } from "../../typings/types"

export const getUniqueInstancesOfProperty = <Thing, ThingProperty extends keyof Thing>(
  things: Thing[],
  key: ThingProperty
): Thing[ThingProperty][] => {
  const valuesFromThings = things.map(prod => prod[key])
  return Array.from(new Set(valuesFromThings))
}

/*
  Transforms a flat list of products into an array of ProductGroups
  ProductGroup represents a set of products of the same drugType and dosageType (with different dosage/amount values)
*/
export const transform = ({
  displayedProducts
}: {
  displayedProducts: GetDisplayedProductsDisplayedProducts[]
}): ProductGroup[] => {
  const allProducts: ProductGroup[] = []

  const productGroups: ProductGroupDisplayType[] = displayedProducts.map(
    ({ drugType, genericName, needsPrescription, drugCategory, drugFactsPath, dosageType }) => ({
      drugType,
      dosageType: dosageType!,
      genericName,
      needsPrescription,
      drugFactsPath: drugFactsPath!,
      drugCategory: drugCategory!
    })
  )

  const augmentedProducts = displayedProducts.map(p => {
    const { price, drugCategory, dosageType, ...productAttrs } = p

    return {
      ...productAttrs,
      drugCategory: drugCategory!,
      dosageType: dosageType!,
      price: price || 0
    }
  })

  getUniqueInstancesOfProperty(displayedProducts, "drugType").map(drugType => {
    const productGroupByDrugType = productGroups.find(p => p.drugType === drugType)
    const productGroupByDrugTypeProducts = augmentedProducts.filter(p => p.drugType === drugType)

    getUniqueInstancesOfProperty(productGroupByDrugTypeProducts, "dosageType").map(dosageType => {
      const productGroupProducts = productGroupByDrugTypeProducts.filter(p => p.dosageType === dosageType)

      if (productGroupByDrugType) {
        allProducts.push({
          ...productGroupByDrugType,
          dosageType,
          products: productGroupProducts
        })
      }
    })
  })

  return allProducts
}
